import React, { Component } from 'react';
import classnames from 'classnames';
import Alert from 'components/alerts/Alert/Alert';
import { Link } from 'react-router';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import OngoingAvailability from './Ongoing';
import SpecificAvailability from './Specific';
import './style.css';

const AVAILABILITY_MODE = {
  ONGOING: 'ongoing',
  SPECIFIC: 'specific'
};

class TeacherScheduleAvailability extends Component {
  constructor(props) {
    super(props);

    this.state = {
      counter: 0,
      mode: AVAILABILITY_MODE.ONGOING
    };
  }

  componentDidMount() {
    this.timer = setInterval(this.onTimer, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  onTimer = () => {
    this.setState({
      counter: this.state.counter + 1
    });
  }

  handleClickMode = (mode) => {
    return event => {
      event.preventDefault();
      this.setState({ mode });
    };
  }

  render() {
    const { mode } = this.state;
    const { user } = this.props;

    if (!user.profile.information.timezone) {
      return (
        <Alert alertType="warning">
          You must set your timezone in settings before you can access availability. Go{' '}
          <Link to="/teacher/settings/profile">here</Link>
        </Alert>
      );
    }

    return (
      <div className="teacher-schedule-availability full-height card d-flex">
        <div className="px-4 px-lg-5 pt-4 pt-lg-5">
          <h4>Availability</h4>
          <div className="teacher-schedule-availability__header d-flex align-items-center justify-content-between mt-4">
            <ul className="nav">
              <li className="nav-item">
                <a
                  href="#"
                  className={classnames('nav-link mr-2 mr-sm-4 mr-lg-5', {
                    active: mode === AVAILABILITY_MODE.ONGOING
                  })}
                  onClick={this.handleClickMode(AVAILABILITY_MODE.ONGOING)}
                >
                  Ongoing
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#"
                  className={classnames('nav-link mr-2 mr-sm-4 mr-lg-5', {
                    active: mode === AVAILABILITY_MODE.SPECIFIC
                  })}
                  onClick={this.handleClickMode(AVAILABILITY_MODE.SPECIFIC)}
                >
                  Blocked times
                </a>
              </li>
            </ul>
            <p className="teacher-schedule-availability__time ml-4 mb-0">
              {user.profile.information.timezone}{' '}
              {moment()
                .tz(user.profile.information.timezone)
                .format('h:mma')}
            </p>
          </div>
        </div>
        <div className="d-flex flex-column teacher-schedule-availability__content">
          {mode === AVAILABILITY_MODE.ONGOING && <OngoingAvailability />}
          {mode === AVAILABILITY_MODE.SPECIFIC && <SpecificAvailability />}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

export default connect(
  mapStateToProps,
  {}
)(TeacherScheduleAvailability);



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Availability/index.js